export default __webpack_public_path__ + "static/media/gallery_04.c8de3064.jpg";